import { IconInterface } from '../interfaces/icon.interface';

const StoreSearchPin = (props: IconInterface) => {
	const { isActive } = props;

	return (
		<svg
			width="18"
			height="22"
			viewBox="0 0 18 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 9.14329C1 4.64588 4.58172 1 9 1C13.4183 1 17 4.64588 17 9.14329C17 13.6055 14.4467 18.8124 10.4629 20.6744C9.53426 21.1085 8.46574 21.1085 7.53707 20.6744C3.55332 18.8124 1 13.6055 1 9.14329Z"
				stroke={isActive ? 'none' : '#A2A2A2'}
				fill={isActive ? '#494C83' : 'none'}
			/>
			<circle
				cx="9"
				cy="9"
				r="3"
				stroke={isActive ? 'none' : '#A2A2A2'}
				fill={isActive ? 'white' : 'none'}
			/>
		</svg>
	);
};

export default StoreSearchPin;
